// API for calling the groups inside the company
export async function getCompanyGroups(company) {
    try {
        var myHeaders = new Headers();
        myHeaders.append(
            "Authorization",
            "Basic N2MwNWZiZGFlZTQwYjQ2OmViZmU0YjkxMDVjYTY5MQ=="
        );
        myHeaders.append(
            "Cookie",
            "full_name=Guest; sid=Guest; system_user=no; user_id=Guest; user_image="
        );

        var requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow",
        };
        const response = await fetch(
            `https://erpeyouth.eyouthlearning.com/api/resource/Company Groups?fields=[%22name%22%2C%22company_name%22%2C%22group_name%22]&filters=[["Company Groups","company_name","=","${company}"]]`,
            requestOptions
        );
        const result = await response.json();
        return result;
    } catch (error) {
        console.log("Error:", error.message);
    }
}

// API for getting All-Courses
export async function getAllCourses() {
    try {
        var myHeaders = new Headers();
        myHeaders.append("accept", "application/json");
        myHeaders.append(
            "Cookie",
            "csrftoken=nVddr9vjx3FSzqapqyjtH7Xr0hNZ8GUnKeVUAIQ0dPD1wwZO65WJSr2IodB9OsYY; sessionid=1|98t0fhrzat7jmyvspm5kd1qq4b2on5cq|pk70lojlCeUW|ImY1ZDIwYTJhYmE5NGM4MmY2NmYyYTRjNWUwYWVhYjRhNWEwMDNiMjlhNWNkNzNkNGQzNjAwNzU2MTA0MDU0ZjEi:1rY2OA:gpUgxhk08knrmixgDLKK2LgtiIg"
        );

        var requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow",
        };

        const response = await fetch(
            "https://experience.eyouthlearning.com/api/courses/v1/courses/?page_size=10000",
            requestOptions
        );
        const result = await response.json();
        return result;
    } catch (error) {
        console.log("error", error);
    }
}

// API for getting users inside the courses
export async function getUsers(
    page,
    company_name,
    page_size,
    user_status,
    filter_contains,
    group_contains
) {
    const myHeaders = new Headers();
    myHeaders.append(
        "Cookie",
        "sessionid=1|f8p2ztsdif2crrsv6npygfxsh5j2667l|el18uoozGrFF|ImUwY2IwZWQyZjYzYjA5Mzk0OTE1Mjc5MDc2Y2M0MTVhZTQyYjc1YTQzYmU3ZWZkMjRhY2ZmZTRkYTJiYjBlN2Qi:1raE16:aZjAT5inoQhUfsU_SIYW7SEJQXI"
    );

    const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
    };
    const url = new URL(
        "https://experience.eyouthlearning.com/api/user/v1/userslist"
    );
    url.searchParams.set("page", page);
    url.searchParams.set("page_size", page_size);
    url.searchParams.set("company", company_name);
    url.searchParams.set("is_active", user_status);
    url.searchParams.set("user_contains", filter_contains);
    url.searchParams.set("group", group_contains);

    try {
        const res = await fetch(url.toString(), requestOptions);
        if (!res.ok) {
            throw new Error("API request failed with status code: " + res.status);
        }

        const data = await res.json();
        return data;
    } catch (error) {
        console.error("API Error: ", error);
        return { results: [], total_pages: 0 };
    }
}

// ENROLL USERS In course
export async function EnrollUsersInCourse(
    company_name,
    course_id,
    group_name,
    sent_email,
    token,
    group_or_user,
    Action_button,
    deadlineValue
) {
    try {
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `jwt ${token}`);
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            auto_enroll: true,
            email_students: sent_email,
            action: Action_button,
            courses: course_id,
            [group_or_user]: group_name,
            deadline: deadlineValue
        });

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        const enrollUser = await fetch(
            `https://experience.eyouthlearning.com/api/bulk_enroll/v1/bulk_enroll?company=${company_name}`,
            requestOptions
        );
        return enrollUser.status;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

// change user password
export async function ChangeUserPassword(token, user_username, new_password) {
    try {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("Authorization", `jwt ${token}`);
        myHeaders.append(
            "Cookie",
            "csrftoken=RRHHGx4JF4l5toHKzRhAs5OsrLZZAcOYoOFQQy3P2YfWn2mdPRZnJRD2TM5yEBtM; openedx-language-preference=en; sessionid=1|6x0g2c93ln1hr6c971me9i45kfhln0g4|jwclcwTriPf5|Ijc1NDMyZTg3Yjg4ZWZhOWIxOTg1ZWM2OWMzZTg0NGEzNzczMGIzMmNhNWI0ZjhiYjRiMWEzNDRiYjZjYTYwZjIi:1rbhRV:ialb4DuSpGLjGHWFysNmcprLKQ0"
        );

        const urlencoded = new URLSearchParams();
        urlencoded.append("username", user_username);
        urlencoded.append("new_password", new_password);

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: urlencoded,
            redirect: "follow",
        };

        const res = await fetch(
            "https://experience.eyouthlearning.com/api/user/v1/change_password/",
            requestOptions
        );
        return res.status;
    } catch (error) {
        console.error(error);
    }
}

export async function sendRequest(
    full_name,
    phone_number,
    email,
    company_name,
    company_size,
    website_url,
    service
) {
    try {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            name: full_name,
            phone_number: phone_number,
            work_email: email,
            company_name: company_name,
            company_size: company_size,
            website_url: website_url,
            service: service,
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        const res = await fetch(
            "https://business-django.eyouthlearning.com/company/request/",
            requestOptions
        );
        const result = await res.json();
        return result;
    } catch (error) {
        console.error(error);
    }
}

export async function getComapnyData(Company_name) {
    try {
        const requestOptions = {
            method: "GET",
            redirect: "follow",
        };

        const res = await fetch(`https://business-django.eyouthlearning.com/company/get?name=${Company_name}`, requestOptions)
        const result = await res.json()
        // console.log(result, "results")
        return { data: result, status: res.status };
    } catch (error) {
        console.error(error);
    }
}
// Create Group

export async function CreateGroupName(company_name, group_name) {
    try {
        const myHeaders = new Headers();
        myHeaders.append(
            "Authorization",
            "Basic N2MwNWZiZGFlZTQwYjQ2OmViZmU0YjkxMDVjYTY5MQ=="
        );
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append(
            "Cookie",
            "full_name=Guest; sid=Guest; system_user=no; user_id=Guest; user_image="
        );

        const raw = JSON.stringify({
            company_name: company_name,
            group_name: group_name,
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };
        // eslint-disable-next-line
        const res = await fetch(
            "https://erpeyouth.eyouthlearning.com/api/resource/Company Groups",
            requestOptions
        );
        // const results = await res.json();
    } catch (error) {
        console.error(error);
    }
}

// API for adding users to group
export async function AddUsersInGroup(users, group_name) {
    try {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append(
            "Cookie",
            "csrftoken=RRHHGx4JF4l5toHKzRhAs5OsrLZZAcOYoOFQQy3P2YfWn2mdPRZnJRD2TM5yEBtM; openedx-language-preference=en; sessionid=1|6x0g2c93ln1hr6c971me9i45kfhln0g4|CDP4Y9wrCeGe|Ijc1NDMyZTg3Yjg4ZWZhOWIxOTg1ZWM2OWMzZTg0NGEzNzczMGIzMmNhNWI0ZjhiYjRiMWEzNDRiYjZjYTYwZjIi:1rcoDs:scDlZhlveFVtYu6OMjmgnb6QJuE"
        );

        const raw = JSON.stringify({
            Users: users,
            Group: group_name,
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };
        // eslint-disable-next-line
        const res = await fetch(
            "https://experience.eyouthlearning.com/api/user/v1/change_group",
            requestOptions
        );
        // const results = await res.json();
    } catch (error) {
        console.error(error);
    }
}

// API for deleting users from group
export async function deleteUsersFromGroup(userName, group) {
    try {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append(
            "Cookie",
            "sessionid=1|f8p2ztsdif2crrsv6npygfxsh5j2667l|el18uoozGrFF|ImUwY2IwZWQyZjYzYjA5Mzk0OTE1Mjc5MDc2Y2M0MTVhZTQyYjc1YTQzYmU3ZWZkMjRhY2ZmZTRkYTJiYjBlN2Qi:1raE16:aZjAT5inoQhUfsU_SIYW7SEJQXI"
        );

        const raw = JSON.stringify({
            Users: userName,
            Group: group,
        });
        const requestOptions = {
            method: "DELETE",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        const response = await fetch(
            "https://experience.eyouthlearning.com/api/user/v1/change_group?company=EYouth",
            requestOptions
        );
        if (!response.ok) {
            throw new Error(
                `API request failed with status code: ${response.status}`
            );
        }
        // const result = await response.json();
    } catch (error) {
        console.error("API for deleting users from group error", error);
    }
}

// API to get all course progress details
export async function usersProgress(page_num, company, course_key, group, email) {
    try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer IDtHrt91glsnJAFDaH1Gk1nxdk2UhQ");
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append(
            "Cookie",
            "sessionid=1|f8p2ztsdif2crrsv6npygfxsh5j2667l|el18uoozGrFF|ImUwY2IwZWQyZjYzYjA5Mzk0OTE1Mjc5MDc2Y2M0MTVhZTQyYjc1YTQzYmU3ZWZkMjRhY2ZmZTRkYTJiYjBlN2Qi:1raE16:aZjAT5inoQhUfsU_SIYW7SEJQXI"
        );

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            redirect: "follow",
        };

        const response = await fetch(
            `https://experience.eyouthlearning.com/api/course_home/v1/progress_v2/?page_number=${page_num}&company=${company}&course_key=${course_key}&group=${group}&email=${email}`,
            requestOptions
        );
        if (!response.ok) {
            throw new Error(
                `API request failed with status code: ${response.status}`
            );
        }
        const result = await response.json();
        return result;
    } catch (error) {
        console.error("API to get all course progress details", error);
    }
}
export async function SendEmailForUsers(Email_Subject, User_Emails, Message_Body, company_logo, token, Company_name, users_or_group) {
    try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `jwt ${token}`);
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Cookie", "csrftoken=RRHHGx4JF4l5toHKzRhAs5OsrLZZAcOYoOFQQy3P2YfWn2mdPRZnJRD2TM5yEBtM; openedx-language-preference=en; sessionid=1|6x0g2c93ln1hr6c971me9i45kfhln0g4|97ZEF44zVUmC|Ijc1NDMyZTg3Yjg4ZWZhOWIxOTg1ZWM2OWMzZTg0NGEzNzczMGIzMmNhNWI0ZjhiYjRiMWEzNDRiYjZjYTYwZjIi:1reYFQ:FuEKw0BrDvJHqh_0hMUTN9IkDUM");

        const raw = JSON.stringify({
            "subject": Email_Subject,
            [users_or_group]: User_Emails,
            "message": Message_Body,
            "logo": company_logo,
            "company": Company_name,

        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        const res = await fetch("https://experience.eyouthlearning.com/api/bulk_enroll/v1/bulk_email", requestOptions)
        const result = await res.json();
        return result;
    } catch (error) {
        console.error(error);

    }

}
// register
export async function RegisterUsers(FullName, Username, Email, pasword, phone_number, company_name, Employee_num) {
    try {
        const myHeaders = new Headers();
        myHeaders.append("Cookie", "csrftoken=iu9en1TqPUiJSeHk0oxUH2zP2QWYPWACazCGweQV0WYa46g26rqajrTJwwvlUtfJ; edx-jwt-cookie-header-payload=eyJhbGciOiJSUzUxMiIsImtpZCI6Im9wZW5lZHgifQ.eyJhdWQiOiAib3BlbmVkeCIsICJleHAiOiAxNzA5MDI5OTE0LCAiaWF0IjogMTcwOTAyNjMxNCwgImlzcyI6ICJodHRwczovL2xlYXJuaW5nLmJ1c2luZXNzLmV5b3V0aGxlYXJuaW5nLmNvbS9vYXV0aDIiLCAicHJlZmVycmVkX3VzZXJuYW1lIjogIkVsaGFtSGVzaGEiLCAic2NvcGVzIjogWyJ1c2VyX2lkIiwgImVtYWlsIiwgInByb2ZpbGUiXSwgInZlcnNpb24iOiAiMS4yLjAiLCAic3ViIjogIjQ0MGI3Y2JkMWEzNWIyZmVjZmNmYmE2MzA4YzMzMjIyIiwgImZpbHRlcnMiOiBbInVzZXI6bWUiXSwgImlzX3Jlc3RyaWN0ZWQiOiBmYWxzZSwgImVtYWlsX3ZlcmlmaWVkIjogdHJ1ZSwgInVzZXJfaWQiOiA0MzEsICJlbWFpbCI6ICJlbGhhbWhlc2hhbUBtYWlsLmNvbSIsICJuYW1lIjogIkVsaGFtIEhlaHNhbSBNb2htZWQiLCAiZmFtaWx5X25hbWUiOiAiIiwgImdpdmVuX25hbWUiOiAiIiwgImFkbWluaXN0cmF0b3IiOiBmYWxzZSwgInN1cGVydXNlciI6IGZhbHNlfQ; edx-jwt-cookie-signature=QnhoL2wJQ3_u5YrWdxKumfB-bAwbfFSZjh-L6rSI0RkO2SxON8eclfW20prwu8vQa6A47wYMSuSjqfe-nPa8CDYuh44PXjTO-ESojyCtK2QxPVhawoF1T0TKUGJEk9aiffzcc6aZcTzG4qCUTzOtlw1wpHYfcC6btXe1wAHe0dlIU_2y04aZfmwKCxHBZUxc-UvErrQ0J0WvzSxtdzMHHrPMqDkH3V_a3e4NWZuJy2zLOG9agPTP203n0dyC0GzYS91apFAzSK21EkR55sXqp-qgAvteOxV2HpsBSmgDPIdon2eUsLVKhGx_HX3SPO-uxOQNMQknQMocEHqWlBpX0w; edx-user-info=\"{\\\"version\\\": 1\\054 \\\"username\\\": \\\"ElhamHesha\\\"\\054 \\\"email\\\": \\\"elhamhesham@mail.com\\\"\\054 \\\"header_urls\\\": {\\\"logout\\\": \\\"https://experience.eyouthlearning.com/logout\\\"\\054 \\\"account_settings\\\": \\\"https://experience.eyouthlearning.com/account/settings\\\"\\054 \\\"learner_profile\\\": \\\"https://experience.eyouthlearning.com/u/ElhamHesha\\\"\\054 \\\"resume_block\\\": \\\"https://experience.eyouthlearning.com/api/user/v1/account/registration/\\\"}\\054 \\\"user_image_urls\\\": {\\\"full\\\": \\\"https://experience.eyouthlearning.com/static/images/profiles/default_500.4215dbe8010f.png\\\"\\054 \\\"large\\\": \\\"https://experience.eyouthlearning.com/static/images/profiles/default_120.4a5e0900098e.png\\\"\\054 \\\"medium\\\": \\\"https://experience.eyouthlearning.com/static/images/profiles/default_50.3455a6581573.png\\\"\\054 \\\"small\\\": \\\"https://experience.eyouthlearning.com/static/images/profiles/default_30.deee7287e843.png\\\"}}\"; edxloggedin=true; openedx-language-preference=en; sessionid=1|su4xglmh0a5d61qud3oxmnlknimwuxq6|P04W2FnutTe0|IjJhN2RlYmIzZDExMjhjMjNjMDQ1YTMyMGNmZjk0MGFhOTY3ODg2YzNkMjBkMDg3OTMwNTA5ZGIxNTczZTJhMjki:1retoY:6aGRAFAnLDHcN9Nu9oTtb449khk");

        const formdata = new FormData();
        formdata.append("client_id", "login-service-client-id");
        formdata.append("grant_type", "password");
        formdata.append("name", FullName);
        formdata.append("username", Username);
        formdata.append("email", Email);
        formdata.append("password", pasword);
        formdata.append("phone_number", phone_number);
        formdata.append("mailing_address", company_name);
        formdata.append("terms_of_service", "true");
        formdata.append("employee-num", Employee_num);

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow"
        };
        const res = await fetch("https://experience.eyouthlearning.com/api/user/v1/account/registration/", requestOptions);
        const result = await res.json();

        // if (res.ok) {
        //     console.log("Registration successful");
        // } else {
        //     // Log error message if registration fails
        //     console.error("Registration failed:", result.error);
        // }

        return result;

    } catch (error) {
        console.error("Error during registration:", error);
    }
}

// signin 

export async function Signin(username, Password, company) {
    try {
        const myHeaders = new Headers();
        myHeaders.append("Cookie", "csrftoken=oaAmRJpq1DwfyyIuFTXrKuDEXeta8DTzkqt8MjmV7Dcjcp0BYnM1xmJTj2KfBtEf; sessionid=1|f8p2ztsdif2crrsv6npygfxsh5j2667l|el18uoozGrFF|ImUwY2IwZWQyZjYzYjA5Mzk0OTE1Mjc5MDc2Y2M0MTVhZTQyYjc1YTQzYmU3ZWZkMjRhY2ZmZTRkYTJiYjBlN2Qi:1raE16:aZjAT5inoQhUfsU_SIYW7SEJQXI");

        const formdata = new FormData();
        formdata.append("client_id", "login-service-client-id");
        formdata.append("grant_type", "password");
        formdata.append("token_type", "bearer");
        formdata.append("username", username);
        formdata.append("password", Password);
        formdata.append("company", company);

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow"
        };

        const res = await fetch("https://experience.eyouthlearning.com/oauth2/access_token/", requestOptions)
        const result = await res.json();
        // console.log(result, "result")
        return result;


    } catch (error) {
        console.error(error)

    }
}

export async function SentCSVData(Company_name, File_list) {
    try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", "jwt eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiAib3BlbmVkeCIsICJleHAiOiAxNzA4OTA4MTQwLCAiaWF0IjogMTcwODg3MjE0MCwgImlzcyI6ICJodHRwczovL2xlYXJuaW5nLmJ1c2luZXNzLmV5b3V0aGxlYXJuaW5nLmNvbS9vYXV0aDIiLCAicHJlZmVycmVkX3VzZXJuYW1lIjogImNsYWRtaW4iLCAic2NvcGVzIjogWyJyZWFkIiwgIndyaXRlIiwgImVtYWlsIiwgInByb2ZpbGUiXSwgInZlcnNpb24iOiAiMS4yLjAiLCAic3ViIjogImFkMjlhODg0NTA5MTJiYmQ3ZTc4YzliMThlNWU4YjZkIiwgImZpbHRlcnMiOiBbXSwgImlzX3Jlc3RyaWN0ZWQiOiBmYWxzZSwgImVtYWlsX3ZlcmlmaWVkIjogdHJ1ZSwgImVtYWlsIjogInRlY2hAZXlvdXRoZWd5cHQuY29tIiwgIm5hbWUiOiAiRVlvdXRoIFRlY2ggVGVhbSIsICJmYW1pbHlfbmFtZSI6ICIiLCAiZ2l2ZW5fbmFtZSI6ICIiLCAiYWRtaW5pc3RyYXRvciI6IHRydWUsICJzdXBlcnVzZXIiOiB0cnVlfQ.TcDPS9DSZkNBu0inV7VIeLqAsgwCtfhHaTev2VUw1NE");
        myHeaders.append("Cookie", "csrftoken=iu9en1TqPUiJSeHk0oxUH2zP2QWYPWACazCGweQV0WYa46g26rqajrTJwwvlUtfJ; edx-user-info=\"{\\\"version\\\": 1\\054 \\\"username\\\": \\\"ElhamHesha\\\"\\054 \\\"email\\\": \\\"elhamhesham@mail.com\\\"\\054 \\\"header_urls\\\": {\\\"logout\\\": \\\"https://experience.eyouthlearning.com/logout\\\"\\054 \\\"account_settings\\\": \\\"https://experience.eyouthlearning.com/account/settings\\\"\\054 \\\"learner_profile\\\": \\\"https://experience.eyouthlearning.com/u/ElhamHesha\\\"\\054 \\\"resume_block\\\": \\\"https://experience.eyouthlearning.com/api/user/v1/account/registration/\\\"}\\054 \\\"user_image_urls\\\": {\\\"full\\\": \\\"https://experience.eyouthlearning.com/static/images/profiles/default_500.4215dbe8010f.png\\\"\\054 \\\"large\\\": \\\"https://experience.eyouthlearning.com/static/images/profiles/default_120.4a5e0900098e.png\\\"\\054 \\\"medium\\\": \\\"https://experience.eyouthlearning.com/static/images/profiles/default_50.3455a6581573.png\\\"\\054 \\\"small\\\": \\\"https://experience.eyouthlearning.com/static/images/profiles/default_30.deee7287e843.png\\\"}}\"; edxloggedin=true; openedx-language-preference=en; sessionid=1|7b43xwsgoxnprawtd3v2oxpeixe6dknf|Ohfe9wfMQ8zU|IjRjZTI4ZjUyNTFlM2M3ODFiMDdhYTU2ZjAyY2EyMDhlY2I3NjlkZDU2OTZkYWViYWE0YzQzMWI3MzQ1YzdlMDIi:1rh7M6:jMcePQjvDjFV2uDPS3P1ON2cVLs");

        const formdata = new FormData();
        formdata.append("company", Company_name);
        formdata.append("attachments", File_list);

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow"
        };

        const res = await fetch("https://experience.eyouthlearning.com/api/bulk_enroll/v1/attach_email", requestOptions)
        const result = await res.json();

        console.log('result', result)
        return result;
    } catch (error) {
        console.error(error)

    }

}



export async function getAllCoursesSearch() {
    try {
        var myHeaders = new Headers();
        myHeaders.append("accept", "application/json");
        myHeaders.append(
            "Cookie",
            "csrftoken=nVddr9vjx3FSzqapqyjtH7Xr0hNZ8GUnKeVUAIQ0dPD1wwZO65WJSr2IodB9OsYY; sessionid=1|98t0fhrzat7jmyvspm5kd1qq4b2on5cq|pk70lojlCeUW|ImY1ZDIwYTJhYmE5NGM4MmY2NmYyYTRjNWUwYWVhYjRhNWEwMDNiMjlhNWNkNzNkNGQzNjAwNzU2MTA0MDU0ZjEi:1rY2OA:gpUgxhk08knrmixgDLKK2LgtiIg"
        );

        var requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow",
        };

        const response = await fetch(
            "https://experience.eyouthlearning.com/api/courses/v1/courses/search",
            requestOptions
        );
        const result = await response.json();
        return result;
    } catch (error) {
        console.log("error", error);
    }
}
